import type { ReactNode } from 'react';

import { toast, type ExternalToast } from 'sonner';

type ToastOptions = Omit<ExternalToast, 'duration'> & {
  short?: boolean;
};

export class ToastManager {
  static success(message: ReactNode, { short = true, icon = null, ...options }: ToastOptions = {}) {
    toast.success(message, { ...options, icon, ...(short && { duration: 2_000 }) });
  }

  static error(message: ReactNode, { short = true, icon = null, ...options }: ToastOptions = {}) {
    toast.error(message, { ...options, icon, ...(short && { duration: 2_000 }) });
  }

  static info(message: ReactNode, { short = true, icon = null, ...options }: ToastOptions = {}) {
    toast.info(message, { ...options, icon, ...(short && { duration: 2_000 }) });
  }

  static warning(message: ReactNode, { short = true, icon = null, ...options }: ToastOptions = {}) {
    toast.warning(message, { ...options, icon, ...(short && { duration: 2_000 }) });
  }
}
